import React from 'react';

import { LeadModel } from '@/typings/models/Lead';
import EditableTextField from '@/components/Lead/EditableTextField';
import classNames from 'classnames';
import styles from '@/components/Lead/index.less';


const getLeadTitle = (lead: LeadModel) => lead?.title;

const LeadTitle = ({ lead, readonly, noLink, isTable, isCustomer }: {
  isTable?: boolean,
  lead: LeadModel,
  readonly?: boolean,
  noLink?: boolean,
  isCustomer?: boolean
}) => {
  const leadTitle = getLeadTitle(lead);
  const representation = leadTitle || ' - ';


  return (
    <EditableTextField
      isTable={isTable}
      editable={isCustomer ? false : !readonly}
      lead={lead}
      className={classNames(styles.leadEmailTable, {
        [styles.leadEmailTable]: isTable,
      })}
      property={'title'}
    >
      <span>{representation}</span>
    </EditableTextField>
  );
};

export default LeadTitle;
